
      import { macroCondition, getGlobalConfig, importSync } from '@embroider/macros';
      let config;
      if (macroCondition(getGlobalConfig().fastboot?.isRunning)){
        config = {
  "modulePrefix": "roomba",
  "environment": "production",
  "apollo": {
    "apiURL": "https://app.envoy.com/a/graphql_federated",
    "requestCredentials": "include"
  },
  "roombaBase": "https://app.envoy.com/a/roomba",
  "customerDashHost": "https://customer-dash.envoy.com"
};
      } else {
        config = importSync('./_environment_browser_.js').default;
      }
      export default config;
    